import React, { FunctionComponent } from 'react';
import i18next from 'i18next';

import Table from 'components/commons/Table';

import { ViewContainer, ViewContent } from 'styles/view';

import { IDocumentsViewProps } from './types';

import './i18n';

const DocumentsView: FunctionComponent<IDocumentsViewProps> = (props: IDocumentsViewProps) => {
  const { columns, count, data, loading, onAddClick, onTableUpdate, table } = props;

  return (
    <ViewContainer auth data-testid="documents-view">
      <ViewContent auth>
        <Table
          columns={columns}
          count={count}
          data={data}
          loading={loading}
          onAddClick={onAddClick}
          onTableUpdate={onTableUpdate}
          title={i18next.t<string>('DOCUMENTS_VIEW:TITLE')}
          table={table}
        />
      </ViewContent>
    </ViewContainer>
  );
};

export default DocumentsView;
